import { IBuildFormNode } from '@shared/typings/build/classes/node';
import { tryParseJson } from '@shared/utils/json';

export type CoverResolutionTrack = 'SD' | 'HD' | 'FHD';

const toLabel = (
	n: IBuildFormNode.VideoResolutionEnum | null | undefined,
): CoverResolutionTrack => {
	if (n === IBuildFormNode.VideoResolutionEnum.HD) return 'HD';
	if (n === IBuildFormNode.VideoResolutionEnum.FHD) return 'FHD';
	return 'SD';
};

export const getCoverResolutionTrackLabel = (input: {
	resolution?: IBuildFormNode.VideoResolutionEnum | null;
	param?: string;
	publishSelectedResolution?: IBuildFormNode.VideoResolutionEnum | null;
}): CoverResolutionTrack => {
	let n: IBuildFormNode.VideoResolutionEnum | null | undefined = input.resolution;
	if ((n === undefined || n === null) && input.param) {
		const obj = tryParseJson(input.param) as
			| { videoSpecs?: { resolution?: IBuildFormNode.VideoResolutionEnum | null } }
			| undefined;
		n = obj?.videoSpecs?.resolution ?? undefined;
	}
	if (n === undefined || n === null) {
		n = input.publishSelectedResolution;
	}
	return toLabel(n);
};
